module.exports = __webpack_public_path__ + "img/horizontal_4_4_3009.56904910.png";